/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ years: NonNullable<unknown> }} Onboarding_V1_Projection_YearsInputs */

const en_onboarding_v1_projection_years = /** @type {(inputs: Onboarding_V1_Projection_YearsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} years`)
};

const de_onboarding_v1_projection_years = /** @type {(inputs: Onboarding_V1_Projection_YearsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} Jahre`)
};

const pt_br2_onboarding_v1_projection_years = /** @type {(inputs: Onboarding_V1_Projection_YearsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} anos`)
};

const tr_onboarding_v1_projection_years = /** @type {(inputs: Onboarding_V1_Projection_YearsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} yıl`)
};

const zh_cn2_onboarding_v1_projection_years = /** @type {(inputs: Onboarding_V1_Projection_YearsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years}年`)
};

const zh_hk2_onboarding_v1_projection_years = /** @type {(inputs: Onboarding_V1_Projection_YearsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years}年`)
};

const ko_kr2_onboarding_v1_projection_years = /** @type {(inputs: Onboarding_V1_Projection_YearsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years}년`)
};

const ru_ru2_onboarding_v1_projection_years = /** @type {(inputs: Onboarding_V1_Projection_YearsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} лет`)
};

const es_419_onboarding_v1_projection_years = /** @type {(inputs: Onboarding_V1_Projection_YearsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} años`)
};

/**
* | output |
* | --- |
* | "{years} years" |
*
* @param {Onboarding_V1_Projection_YearsInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_projection_years = /** @type {((inputs: Onboarding_V1_Projection_YearsInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Projection_YearsInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_projection_years(inputs)
	if (locale === "de") return de_onboarding_v1_projection_years(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_projection_years(inputs)
	if (locale === "tr") return tr_onboarding_v1_projection_years(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_projection_years(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_projection_years(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_projection_years(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_projection_years(inputs)
	return es_419_onboarding_v1_projection_years(inputs)
});